import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assignedContacts: [],
  contactOptions: [],
  loading: false,
};

const customerContactsSlice = createSlice({
  name: "customerContacts",
  initialState,
  reducers: {
    setAssignedContacts: (state, action) => {
      state.assignedContacts = action.payload.map((contact) => ({
        ...contact,
        contactID: contact.contactId,
      }));
    },

    updateAssignedContact: (state, action) => {
      const { contactID, updates } = action.payload;
      state.assignedContacts = state.assignedContacts.map((contact) =>
        contact.contactID === contactID ? { ...contact, ...updates } : contact
      );
    },
    addAssignedContact: (state, action) => {
      state.assignedContacts.push(action.payload);
    },
    removeAssignedContact: (state, action) => {
      state.assignedContacts = state.assignedContacts.filter(
        (contact) => contact.contactID !== action.payload
      );
    },
    setContactOptions: (state, action) => {
      state.contactOptions = action.payload;
    },
    setContactsLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const {
  setAssignedContacts,
  updateAssignedContact,
  addAssignedContact,
  removeAssignedContact,
  setContactOptions,
  setContactsLoading,
} = customerContactsSlice.actions;

export const selectAssignedContacts = (state) =>
  state.contacts.assignedContacts;
export const selectContactOptions = (state) => state.contacts.contactOptions;
export const selectContactsLoading = (state) => state.contacts.loading;

export default customerContactsSlice.reducer;
